import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import useEditorStore from '../Editor/EditorStore';
import { LogoGraphics } from './LogoGraphics';
import { LogoTextGraphics } from './LogoTextGraphics';
import useMenuStore from '../Menu/menuStore';
import Menu from '../Menu/Menu';
import MenuButton from '../UI/MenuButton';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import usePageStore from '../Page/pageStore';
import useDataStore from '../Data/dataStore';
import { API, connectPath } from '../globalUtils';
import { getPath } from '../Router/Router';
import GradientWrapper from '../GradientBox/GradientWrapper';
const Header = () => {
    const navigate = useNavigate();
    const urlPath = useLocation().pathname;
    const { open: menuOpen } = useMenuStore();
    const { isLastSection } = usePageStore();
    const setup = useDataStore((state) => state.data[API.setup]);
    //const [isConnectHidden, setIsConnectHidden] = useState(true);
    const [_, setRender] = useState(0);
    const isLogoClosed = useRef(false);
    const connectButton = setup?.main_menu_connect_button;
    const isConnectPage = getPath(urlPath) === connectPath;
    useEffect(() => {
        window.addEventListener('scroll', onScrollEvent);
        return () => {
            window.addEventListener('scroll', onScrollEvent);
        };
    }, []);
    const onScrollEvent = () => {
        if (document.documentElement.scrollTop > 0 && !isLogoClosed.current) {
            isLogoClosed.current = true;
            setRender((x) => x + 1);
        }
        if (document.documentElement.scrollTop <= 0 && isLogoClosed.current) {
            isLogoClosed.current = false;
            setRender((x) => x + 1);
        }
    };
    const openMenu = () => {
        useMenuStore.getState().setOpen(true);
    };
    const gotoHome = () => {
        navigate('/');
    };
    const { editCurve } = useEditorStore();
    return !editCurve ? (_jsxs("div", { className: "header-container", children: [_jsx("div", { className: "header-left", children: _jsxs("div", { className: `logo${isLogoClosed.current ? ' closed' : ''}`, onClick: gotoHome, children: [_jsx(LogoGraphics, {}), _jsx(LogoTextGraphics, {})] }) }), _jsxs("div", { className: `header-right${isLastSection ? ' hidden' : ''}`, children: [_jsx(MenuButton, { onClick: openMenu }), _jsxs("div", { className: `header-connect-button${!menuOpen && !!connectButton && !isConnectPage ? '' : ' hidden'}`, children: [_jsx(GradientWrapper, { active: false }), _jsx(Link, { to: connectButton?.url, children: _jsx("div", { className: "button", children: connectButton?.title }) })] })] }), _jsx(Menu, {})] })) : null;
};
export default Header;
